import { FC } from 'react';

import { Notification } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';

import { SuggestionsWrapper } from './SearchSuggestions.styles';

export const SuggestionsError: FC = () => {
    const { t } = useTranslations();

    return (
        <SuggestionsWrapper>
            <Notification status="error" heading={t['search.suggestions.error.title']}>
                <HtmlContent content={t['search.suggestions.error.message']} />
            </Notification>
        </SuggestionsWrapper>
    );
};
